import { Grid } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import { PATHS } from 'constants/paths';
import { generatePath } from 'react-router';
import { NavLink } from 'react-router-dom';

import styles from './SidebarContentEnergyEffiency.module.scss';

const SidebarContentEnergyEffiency = () => {
  return (
    <Grid direction="column" className={styles.linksContainer} container>
      <Grid item>
        <NavLink
          to={generatePath(PATHS.ENERGY_EFFICIENCY_HOME)}
          className={styles.link}
          activeClassName={styles.activeLink}
        >
          <Grid className={styles.linkContent} container>
            <HomeIcon />
            <Grid item className={styles.linkLabel}>
              Home
            </Grid>
          </Grid>
        </NavLink>
      </Grid>
    </Grid>
  );
};

export default SidebarContentEnergyEffiency;
